import * as React from 'react';
import { Modal } from 'antd';

// import styles from './index.less';
import type { ModalProps } from 'antd/lib/modal';

interface FModalProps extends Omit<ModalProps, 'title' | 'footer'> {
  // children?: React.ReactNode;
}

function FModal({ styles, style, ...props }: FModalProps) {
  return (
    <Modal
      {...props}
      title={null}
      footer={null}
      style={{
        borderRadius: 6,
        overflow: 'hidden',
        padding: 0,
        ...(style || {}),
      }}
      styles={{
        mask: {
          ...(styles?.mask || {}),
        },
        content: {
          borderRadius: 6,
          overflow: 'hidden',
          padding: 0,
          ...(styles?.content || {}),
        },
        wrapper: {
          ...(styles?.wrapper || {}),
        },
        // header: {
        //   ...(styles?.header || {}),
        // },
        body: {
          borderRadius: 6,
          overflow: 'hidden',
          padding: 0,
          ...(styles?.body || {}),
        },
        // footer: {
        //   ...(styles?.footer || {}),
        // },
      }}
    />
  );
}

export default FModal;
